<template>
    <div>
        <el-form :model="roleInfo" :rules="roles" ref="roleInfo" class="demo-ruleForm">
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">岗位名称</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="name">
                            <el-input :disabled="state != 0" v-model="roleInfo.name" class="width-2x" type="text" auto-complete="off"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>描述</label>
                    </div>
                    <div class="form-value">
                        <el-form-item>
                            <el-input :disabled="state != 0" class="width-2x" type="textarea" :rows="2" placeholder="请输入描述" v-model="roleInfo.desc"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="content-caption dashed">
            <span>需要添加岗位的部门</span>
            <button type="button" class="swb-btn swb-btn-small" @click="selectCom()" v-if="state == 0">选择机构</button>
            <button class="swb-btn swb-btn-small fr" @click="start" v-if="state == 0">创建岗位</button>
        </div>
        <div class="table-layout">
            <el-progress :text-inside="true" :stroke-width="20" :percentage="percentage" status="success" v-if="state != 0"></el-progress>
            <el-table :data="comList" border style="width: 100%; height: 430px; overflow-y: scroll">
                <el-table-column width="50" prop="index" align="center" label="序号">
                    <template slot-scope="rows">
                        <span>{{ rows.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="bizUnitName" label="业务单元"></el-table-column>
                <el-table-column prop="name" label="业务部门"></el-table-column>
                <el-table-column width="100" prop="shopFlag" align="center" label="是否门店">
                    <template slot-scope="rows">
                        <span>{{rows.row.shopFlag ? '是' : '否'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="状态" v-if="state != 0">
                    <template slot-scope="rows">
                        <span v-if="rows.row.success" class="font-green">成功</span>
                        <span class="font-red" v-else>{{ rows.row.message }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="操作" align="left" width="100" v-if="state == 0">
                    <template slot-scope="rows">
                        <div class="swb-btn swb-btn-link" @click="rmoveCom(rows.$index)">移除</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    //
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openServicerComListForSelectDlg } from '../orgStruct/selectDlg'

    import servicerAuthxApi from '../../api/servicerAuthx'

    //
    export default {
        name: 'swb-save-com-role-batch',
        desc: '保存公司岗位',
        props: ['tplRole'],
        data: function () {
            let validateNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    callback();
                }
            };
            //
            return {
                roleInfo: {
                    name: null,
                    desc: null,
                    srcTplId: null
                },
                roles: {
                    name: [{validator: validateNull, trigger: 'blur'}]
                },
                comList: [],
                //
                state: 0, // 全局状态 0 未开始 1进行中 2执行完成
                percentage: 0
            }
        },
        created: function () {
            this.roleInfo.srcTplId = this.tplRole.id;
            this.roleInfo.name = this.tplRole.realName;
        },
        methods: {
            selectCom(){
                let self = this;
                let comList = this.comList;
                let disabledIds = comList.pluck('id');
                let params = {
                    disabledIds: disabledIds,
                    bizUnitType: this.tplRole.bizUnitType
                };
                openServicerComListForSelectDlg(params, function (result, theDlg) {
                    theDlg.close();
                    comList.add(result || []);
                    self.comList = Utils.merge([], comList);
                })
            },
            rmoveCom(index){
                this.comList.split(index, 1);
            },
            start: function () {
                // 提供回调函数，返回结果
                let self = this;
                this.$refs['roleInfo'].validate(function (valid) {
                    if(valid) {
                        let comList = self.comList;
                        if(comList.length == 0){
                            self.$message.warning('请选择需要添加岗位的部门');
                            return;
                        }
                        //
                        self.state = 1;
                        let theLoading = MsgBox.loading();
                        self.doAddRole(0, function () {
                            theLoading.close();
                            self.state = 2;
                        });
                    }
                });
            },
            doAddRole(index, callback){
                let self = this;
                let roleInfo = Utils.merge({}, this.roleInfo);
                roleInfo.comId = this.comList[index].id;
                roleInfo.comLevel = this.comList[index].level;
                //
                servicerAuthxApi.saveServicerComRole(roleInfo, function (result) {
                    self.comList[index].success = result.type == "info";
                    self.comList[index].message = result.message;
                    self.comList = Utils.merge([], self.comList);
                    //
                    index++;
                    self.percentage = parseInt(index / self.comList.length * 100);
                    if(self.comList.length != index){
                        self.doAddRole(index, callback);
                    } else {
                        callback();
                    }
                });
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/authx/SaveComRoleBatch.vue